/* eslint-disable class-methods-use-this */
import Cropper from 'cropperjs';
import { getCurrentState } from '../../store/store-utils';

const templateCropContainer = document.createElement('template');

templateCropContainer.innerHTML = `<section class="popup crop-popup" id="popup" content="">
                                      <div class="crop-content">
                                        <div class="crop-body"></div>
                                        <div class="crop-footer"></div>

                                      </div>
                                    </section>`;

const templateCropBody = document.createElement('template');

templateCropBody.innerHTML = `<img class="crop-image" src="" style="max-width: 100%;display: block;">`;

const templateSaveCancelForCrop = document.createElement('template');

templateSaveCancelForCrop.innerHTML = `<button class="btn-cta save-image">Save</button><button class="btn cancel-btn">Cancel</button>`;

export default class Crop extends HTMLElement {
  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  static get observedAttributes() {
    return ['mode'];
  }

  connectedCallback() {
    this.appendChild(templateCropContainer.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'mode' && newVal) {
      if (newVal === 'open') {
        this._buildCropper(
          this._file,
          this._minHeight,
          this._minWidth,
          this._componentName
        );
      }
      if (newVal === 'close') {
        this.querySelector('.crop-popup').querySelector(
          '.crop-body'
        ).innerHTML = '';
        this.dispatchEvent(new CustomEvent('removeFile', {}));
        this.remove();
      }
    }
  }

  async _buildCropper(e, minHeight, minWidth, componentName) {
    try {
      const cropPopup = this.querySelector('.crop-popup');

      cropPopup.querySelector('.crop-body').innerHTML = '';
      let cropperObj = {};
      cropPopup
        .querySelector('.crop-body')
        .append(templateCropBody.content.cloneNode(true));

      cropperObj = await this._getCropper(e, minHeight, minWidth, cropperObj);
      const cropFooter = cropPopup.querySelector('.crop-footer');

      cropFooter.innerHTML = '';

      const saveCancel = templateSaveCancelForCrop.content.cloneNode(true);
      cropFooter.append(saveCancel);

      cropFooter.querySelector('.save-image').addEventListener(
        'click',
        async () => {
          // get file
          const file = await this._getCroppedFile(
            cropperObj,
            this.querySelector('.crop-image').getAttribute('file-name')
          );
          // get link after upload
          if (file) {
            const uploadUrl = await this._getUploadUrl(
              file.name,
              componentName === 'au-profile-popup' ? 'profile' : ''
            );
            // set attribute upload with link to the component
            if (uploadUrl) {
              const link = await this._uploadFile(file, uploadUrl);
              if (link) {
                this.dispatchEvent(
                  new CustomEvent('afterUpload', {
                    detail: {
                      link
                    }
                  })
                );
              }
            }
          }
          this.setAttribute('mode', 'close');
        },
        true
      );

      cropFooter.querySelector('.cancel-btn').addEventListener('click', () => {
        cropPopup.classList.remove('open');
        this.setAttribute('mode', 'close');
      });
    } catch (error) {
      console.error(`Error while building cropper:: ${error.message}`); // 30
    }
  }

  // eslint-disable-next-line class-methods-use-this
  _getOptions() {
    const minWidth = this._minWidth;
    const minHeight = this._minHeight;
    const ratio = minWidth / minHeight;

    const options = {
      aspectRatio: ratio,
      guides: false,
      viewMode: 1,
      autoCropArea: 1,
      zoomOnTouch: false,
      zoomOnWheel: false,
      background: false,
      highlight: false,
      minCropBoxHeight: minHeight,
      minCropBoxWidth: minWidth
    };
    return options;
  }

  // used promise because reader.onload property is not a promise, nor we are  assigning it one. to return the crop object once the load is done then we have to use promise
  _getCropper(e, minHeight, minWidth) {
    try {
      let cropperObj;
      return new Promise((resolve) => {
        if (e.target.files[0]) {
          const reader = new FileReader();
          reader.onload = (evt) => {
            const img =
              this.querySelector('.crop-popup').querySelector('.crop-image');
            img.src = evt.target.result;
            img.setAttribute('file-name', e.target.files[0].name);

            img.onload = (event) => {
              if (
                event.target.height < minHeight ||
                event.target.width < minWidth
              ) {
                this.dispatchEvent(
                  new CustomEvent('statusMsg', {
                    detail: {
                      msg: `Please upload ${minWidth}w x ${minHeight}h image or higher`,
                      status: 'warning'
                    }
                  })
                );
                this.setAttribute('mode', 'close');
                return false;
              }
              // afterCropHideElements(component);
              this.querySelector('.crop-popup').classList.add('open');
              return true;
            };
            if (cropperObj) cropperObj.destroy();

            cropperObj = new Cropper(img, this._getOptions());

            cropperObj.setCropBoxData({
              height: this.minHeight,
              width: this._minWidth
            });

            resolve(cropperObj);
          };
          reader.readAsDataURL(e.target.files[0]);
        }
      });
    } catch (error) {
      console.error(`Error while get cropper:: ${error.message}`);
      return {};
    }
  }

  // used promise because reader.onload property is not a promise, nor we are  assigning it one. to return the crop object once the load is done then we have to use promise
  _getCroppedFile(cropper, fileName, file) {
    try {
      return new Promise((resolve) => {
        cropper
          .getCroppedCanvas({
            minWidth: 256,
            minHeight: 256,
            maxWidth: 4096,
            maxHeight: 4096,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high'
          })
          .toBlob(
            (blob) => {
              const reader = new FileReader();

              // this function is triggered once a call to readAsDataURL returns
              reader.onload = () => {
                file = new File([blob], fileName, { type: blob.type });
                resolve(file);
              };
              // trigger the read from the reader...
              reader.readAsDataURL(blob);
            },
            'image/jpeg',
            1
          );
      });
    } catch (e) {
      console.error(`Error while get cropped file:: ${e.message}`);
      return {};
    }
  }

  async _uploadRequestAjax(req) {
    const headers = new Headers();
    if (req.contentType) {
      headers['Content-Type'] = req.contentType;
    }
    if (req.method !== 'GET') {
      const { csrfToken, csrfHeader } = getCurrentState().initialData;

      if (csrfToken && csrfHeader) headers.append(csrfHeader, csrfToken);
    }
    const initData = {
      method: req.method,
      body: req.data,
      headers
    };
    try {
      return (await fetch(new Request(req.url, initData))).json();
    } catch (e) {
      return {};
    }
  }

  async _getUploadUrl(name, type) {
    try {
      const generateUploadURL = {};
      generateUploadURL.method = 'POST';

      if (type && type === 'profile') {
        generateUploadURL.url = `/api/v1/university/${this.getAttribute(
          'univ-semantic-name'
        )}/generateProfilePicUrl`;
        generateUploadURL.data = name;
      } else
        generateUploadURL.url = `/api/v1/university/${this.getAttribute(
          'univ-semantic-name'
        )}/generateUploadUrl?fileName=${name}`;

      this.querySelector('.crop-popup')
        .querySelector('.save-image')
        .classList.add('loader');

      const urlResponse = await this._uploadRequestAjax(generateUploadURL);

      if (urlResponse) {
        return urlResponse.data.url;
      }
    } catch (e) {
      console.error(`Error while get upload url:: ${e.message}`);
    }
    return '';
  }

  async _uploadFile(file, url) {
    try {
      const data = new FormData();

      data.append('files', file);

      const uploadRequest = {};
      uploadRequest.url = url;
      uploadRequest.method = 'POST';
      uploadRequest.data = data;

      const linkResponse = await this._uploadRequestAjax(uploadRequest);
      if (
        linkResponse.ok &&
        linkResponse &&
        linkResponse.data &&
        linkResponse.data.files[0]
      ) {
        this.querySelector('.crop-popup')
          .querySelector('.save-image')
          .classList.remove('loader');
        this.querySelector('.crop-popup').classList.remove('open');

        return linkResponse.data.files[0].img_serve_url;
      }
    } catch (e) {
      console.error(`Error while upload  file:: ${e.message}`);
    }
    return '';
  }
}
